namespace GeniuzPOS.Administration {
    export interface PsPosFuncForm {
        FuncId: Serenity.StringEditor;
        FuncDesc: Serenity.StringEditor;
        FuncKeyLable: Serenity.StringEditor;
        FunLevel: Serenity.LookupEditor;
        FuncUsage: Serenity.BooleanEditor;
    }

    export class PsPosFuncForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsPosFunc';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPosFuncForm.init)  {
                PsPosFuncForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(PsPosFuncForm, [
                    'FuncId', w0,
                    'FuncDesc', w0,
                    'FuncKeyLable', w0,
                    'FunLevel', w1,
                    'FuncUsage', w2
                ]);
            }
        }
    }
}
